import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

import windowResize from './window-resize';
import smoothScroll from './smooth-scroll';
import onCustomizer from './customizer';
import { onNavigation, onSubMenu } from './navigation';
import onFooter from './footer';
import fcSlider from './featured-courses-slider';
import ccSlider from './courses-slider';
import pcSlider from './programmes-slider';
import acSlider from './accreditations-slider';
import tsSlider from './testimonials-slider';
import { toggleAccordion, toggleAccordionMobile } from './accordion';
import showMoreLink from './show-more';
import { onSearch, onResults } from './search';
import onStudy from './study';
import { onValidate, paymentForm } from './form';
import onMobileFilter from './filter';
import onVideo from './video';
import onPodcast from './podcast';
import responsiveTable from './responsive-table';
import webChat from './web-chat';
// import revSlider from './rev-slider'; js added direct to plugin

jQuery(() => {
  windowResize();
  smoothScroll();
  onCustomizer();
  onNavigation();
  onSubMenu();
  onFooter();
  fcSlider();
  ccSlider();
  pcSlider();
  acSlider();
  tsSlider();
  toggleAccordion();
  toggleAccordionMobile();
  showMoreLink();
  onSearch();
  onResults();
  onStudy();
  onValidate();
  paymentForm();
  onMobileFilter();
  onVideo();
  onPodcast();
  responsiveTable();
  webChat();
  // ... any other imports and calls
});
